module.exports = __webpack_public_path__ + "static/media/riskScoreOne.ddf5df1d.mp3";